module.exports = __webpack_public_path__ + "img/001.f6ddda21.png";